import { style } from '@vanilla-extract/css';
import { bodyTextPreset, radiusVars, spacingVars } from '@tundr/ds-foundations';
import { semanticTokenVars } from '@tundr/ds-tokens';

import { BASE_TRANSITION as TRANSITION_DURATION } from '../../_shared/styles/motion';
export const dropdownItemClass = style({
  display: 'flex',
  alignItems: 'center',
  gap: spacingVars.sm,
  width: '100%',
  height: 40,
  padding: spacingVars.sm,
  borderRadius: radiusVars.sm,
  backgroundColor: semanticTokenVars.surface.background.neutral.default.base,
  cursor: 'pointer',
  transition: `background-color ${TRANSITION_DURATION}`,
  ...bodyTextPreset,
  // <button> resets so the item renders identically to the previous <div>
  appearance: 'none',
  border: 'none',
  textAlign: 'left',
  color: 'inherit',

  selectors: {
    '&:hover, &:focus-visible': {
      backgroundColor: semanticTokenVars.surface.background.brand.default.muted,
    },
  },
});

/*
  Declared after dropdownItemClass in the same stylesheet so it reliably
  overrides its gap without specificity hacks.
*/
export const dropdownItemWideGapClass = style({
  gap: spacingVars.md,
});

export const dropdownItemSelectedClass = style({
  backgroundColor: semanticTokenVars.surface.background.brand.default.muted,
  color: semanticTokenVars.content.action.base,
});

export const dropdownItemDisabledClass = style({
  color: semanticTokenVars.content.disabled.default,
  cursor: 'not-allowed',
  pointerEvents: 'none',
});

export const dropdownItemIconClass = style({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 20,
  height: 20,
  flexShrink: 0,
  color: semanticTokenVars.content.muted.default,
});

export const dropdownItemTooltipTriggerClass = style({
  display: 'flex',
  width: '100%',
  cursor: 'not-allowed',
});
